import { FieldPath } from '../../models/FieldPath.model';
import { FieldValidator } from '../../models/FieldValidator.model';
import { ValidationRules } from '../../models/ValidationRuleNames.model';
import { createRequiredValidator } from '../commons/required.validator';

export function createAddressSubFieldValidatorsMap(
    nullable: boolean,
    customMessages?: Record<ValidationRules, string>,
): Record<FieldPath, FieldValidator[]> {
    const customMsg = customMessages?.required;
    return {
        $self: [ createRequiredValidator(nullable, { fieldName: 'Address', customMsg }) ],
        country: [ createRequiredValidator(nullable, { fieldName: 'Country', customMsg }) ],
        street: [ createRequiredValidator(nullable, { fieldName: 'Street Address', customMsg }) ],
        city: [ createRequiredValidator(nullable, { fieldName: 'City', customMsg }) ],
        state: [ createRequiredValidator(nullable, { fieldName: 'State', customMsg }) ],
        zipCode: [ createRequiredValidator(nullable, { fieldName: 'Zip', customMsg }) ],
    } as Record<string, FieldValidator[]>;
}
